<ion-accordion-group>
  <ion-accordion *ngFor="let mainItem of accordionItems" [value]="mainItem.value">
    <ion-item slot="header" color="light">
      <ion-label>{{ mainItem.label }}</ion-label>
    </ion-item>
    <div class="ion-padding" slot="content">
        <ion-text *ngIf="mainItem.content.text" color="dark">
          {{ mainItem.content.text }}
        </ion-text>

        <ion-item *ngFor="let item of mainItem.content.list; let last=last" [lines]="last ? 'none' : null">
          {{ item }}
        </ion-item>      
        <ion-accordion-group>
          <ion-accordion *ngFor="let subItem of mainItem.subItems" [value]="subItem.value">
            <ion-item slot="header" color="light">
              <ion-label>{{ subItem.label }}</ion-label>
            </ion-item>
            <div class="ion-padding" slot="content">
              <ion-text *ngIf="subItem.content.text" color="dark">
                {{ subItem.content.text }}
              </ion-text>

              <ion-item *ngFor="let item of subItem.content.list; let last=last" [lines]="last ? 'none' : null">
                {{ item }}
              </ion-item>
            </div>
          </ion-accordion>
      </ion-accordion-group>
    </div>
  </ion-accordion>
</ion-accordion-group>